import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';
import AnimatedSection from '../../components/ui/AnimatedSection';
import SectionHeading from '../../components/ui/SectionHeading';
import SafeIcon from '../../common/SafeIcon';

const CoreServices = () => {
  const { FiArrowRight } = FiIcons;

  const services = [
    { 
      title: "NYC Local SEO", 
      desc: "Dominate the Google Local Map Pack across Manhattan, Brooklyn, Queens, Bronx, and Staten Island. We optimize your Google Business Profile for hyper-local visibility.",
      path: "/nyc-local-seo"
    },
    { 
      title: "Technical SEO Audits", 
      desc: "We fix underlying code, improve Website Speed Optimization, and ensure flawless mobile rendering so search engine crawlers rank you higher instantly.",
      path: "/services/technical-seo"
    },
    { 
      title: "Content Marketing", 
      desc: "High-authority, semantically rich content designed to establish your brand as the definitive thought leader in your specific NYC industry.",
      path: "/services/content-marketing"
    },
    { 
      title: "AI Citation & Entities", 
      desc: "Building strong citation networks and optimizing your digital entity so AI models inherently trust and recommend your business to users.",
      path: "/services/ai-citation"
    },
    { 
      title: "Reputation Management", 
      desc: "Monitoring and enhancing your online reviews and brand sentiment, a critical ranking factor for local New York City businesses.",
      path: "/services/reputation-management"
    },
    { 
      title: "Enterprise SEO Solutions", 
      desc: "Scalable, aggressive SEO strategies for large corporations and SaaS startups headquartered in NYC facing fierce national and global competition.",
      path: "/services/enterprise-seo"
    }
  ];

  return (
    <section className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="Our Expertise" 
            title="Comprehensive NYC SEO Services" 
            description="From traditional keyword ranking to advanced Generative Engine Optimization, we provide end-to-end digital visibility for New York's most ambitious brands." 
          />
        </AnimatedSection>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <AnimatedSection key={index} delay={index * 0.1}>
              <Link 
                to={service.path}
                className="block bg-slate-950 p-8 rounded-xl border border-slate-800 hover:border-blue-500 transition-all duration-300 shadow-lg group h-full"
              >
                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-400 leading-relaxed text-sm">
                  {service.desc}
                </p>
                <div className="mt-6 flex items-center text-blue-500 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  Learn More <SafeIcon icon={FiArrowRight} className="ml-2" />
                </div>
              </Link>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreServices;